import React from 'react'

import googleImg from '../img/googleStoreImage.png'
import appleImg from '../img/iOSStoreImage.png'

import bookImg from "../img/elm-acc-cover.png"
import appImg from "../img/elm-acc-app.png"
import audioImg from "../img/elm-acc-audio.png"

import Link from 'gatsby-link'
import StoreLinks from "./storeLinks";

const title = "Elm Accelerated";

const Formats = () => <div className="formats">

  <div>
    <h2>The Book</h2>

    <img src={bookImg} style={{paddingBottom: 38}} />

    <p>Like something traditional? A concise, clear introduction to Elm and its core libraries.</p>

    <p>The books are free and should work great on e-readers like a Kindle.</p>

    <a href="https://s3.eu-west-2.amazonaws.com/elm-accelerated-downloads/ElmAccelerated.epub" alt={`${title} epub`}><div className="webLink">ePub</div></a>

    <a href="https://s3.eu-west-2.amazonaws.com/elm-accelerated-downloads/ElmAccelerated.mobi" alt={`${title} mobi`}><div className="webLink">Mobi</div></a>

  </div>

  <div>
    <h2>The App</h2>

    <img src={appImg} />

    <p>An innovative approach to learning programming. The App has over one hundred flash cards and tracks your fluency at each.</p>

    <p>It includes the full book text so you can look up anything you are struggling with. Don't just learn Elm, get fluent at it.</p>

    <StoreLinks iOSStoreLink="https://itunes.apple.com/us/app/elm-accelerated/id1303935533?ls=1&mt=8"/>
  </div>

  <div>
    <h2>The Audio Book</h2>

    <img src={audioImg} />

    <p>A 10 or so minute summary of the key points from Elm Accelerated. Set to repeat?</p>

    <a href="https://s3.eu-west-2.amazonaws.com/elm-accelerated-downloads/ElmAcceleratedAudio.zip" alt={`${title} in Audio`}><div className="webLink">MP3</div></a>

    <h2 style={{paddingTop: 28}}>Even More</h2>

    <p>Do a quick online Elm quiz or see sample chapters and resources.</p>

    <Link to="/elm" className="main-button elm-bg" style={{margin: 5}}>Quiz, sample chapters and resources on Elm</Link>
  </div>
</div>

export default Formats;


// WEBPACK FOOTER //
// ./src/components/Formats.js